import Spinner from "@atlaskit/spinner";

const LoadingIndicator = ({ currentData }) => {
    if (currentData && !currentData.ihubConfigIsCreated) {
      return (
        <>
        <br/>
        <br/>
          Creating integration flow...
          <Spinner />
        </>
      );
    }
    return null;
  };
   export default LoadingIndicator;
  